// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__iMYsA","title":"Footer_title__JJlvP"};